import { Link } from 'react-router-dom'

const Hero = () => {
    return (
        <section id="home" className="section hero" role="banner">
            <div className="section-inner">
                <h1 className="title title-h1">Professional<br aria-hidden="true" />Web Design</h1>
                <h2 className="subtitle subtitle-h2">Boutique Digital Agency — Centurion, Pretoria &amp; Beyond</h2>
                <p className="description">
                    Custom websites, digital marketing &amp; intelligent automation — built for South African businesses ready to grow online. Mobile-first, POPIA-compliant and built to rank on Google from day one.
                </p>
                <div className="hero-buttons">
                    <Link to="/portfolio" className="btn btn-primary" aria-label="View Our Work - Portfolio">View Our Work</Link>
                    <a href="#contact" className="btn btn-secondary" aria-label="Get in Touch - Contact Form">Get in Touch</a>
                </div>
            </div>
        </section>
    )
}

export default Hero
